import { Box, IconButton } from '@mui/material';
import Popover from '@mui/material/Popover';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MdMoreVert } from 'react-icons/md';

import { accountsSlice } from 'app/store';
import { selectPanelInfo } from 'features/common/editPanelSlice';
import { getContentVersionPanelVis } from 'features/globals/visibilitySlice';
import { selectActionModalInfo } from 'GeminiViewerComponent/features/common/actionModalSlice';
import { ContentPopup } from 'components/Misc/PopupActions/components/ContentPopup';
import { LinkPopup } from 'components/Misc/PopupActions/components/LinkPopup';
import { ItemPopup } from 'components/Misc/PopupActions/components/ItemPopup';
import { ZonePopup } from 'components/Misc/PopupActions/components/ZonePopup';
import { AssetPopup } from 'components/Misc/PopupActions/components/AssetPopup';
import { UserManagementPopup } from 'components/Misc/PopupActions/components/UserManagementPopup';
import { UserProfilePopup } from 'components/Misc/PopupActions/components/UserProfilePopup';
import { GroupManagementPopup } from 'components/Misc/PopupActions/components/GroupManagementPopup';
import { TagManagementPopup } from 'components/Misc/PopupActions/components/TagManagementPopup';
import { AudienceManagementPopup } from 'components/Misc/PopupActions/components/AudienceManagementPopup';
import { HotspotManagementPopup } from 'components/Misc/PopupActions/components/HotspotManagementPopup';
import { ToolsCategoryPopup } from 'components/Misc/PopupActions/components/ToolsCategoryPopup';
import { CategoryManagementPopup } from 'components/Misc/PopupActions/components/CategoryManagementPopup';
import { LocationManagementPopup } from 'components/Misc/PopupActions/components/LocationManagementPopup';
import { ToolsManagementPopup } from 'components/Misc/PopupActions/components/ToolsManagementPopup';
import { PartsManagementPopup } from 'components/Misc/PopupActions/components/PartsManagementPopup';
import { PartsGroupManagementPopup } from 'components/Misc/PopupActions/components/PartsGroupManagementPopup';
import { PartsCategoryManagementPopup } from 'components/Misc/PopupActions/components/PartsCategoryManagementPopup';
import { CompanionAppsPopup } from 'components/Misc/PopupActions/components/CompanionAppsPopup';
import { SnippetPopup } from 'components/Misc/PopupActions/components/SnippetPopup';
import { NewsFlashPopup } from 'components/Misc/PopupActions/components/NewsFlashPopup';
import { JobStatusAssetExportPopup } from './components/JobStatusAssetExportPopup';
import { ManagementDeployPackagePopup } from './components/ManagementDeployPackagePopup';
import { ClientManagementPopup } from './components/ClientManagementPopup';
import { Role } from 'helpers';

function PopupActions({ object, level, targetPopup, size = 'large' }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const editPanelInfo = useSelector(selectPanelInfo);
    const actionModalInfo = useSelector(selectActionModalInfo);
    const contentVersionVis = useSelector(getContentVersionPanelVis);
    const activeUser = useSelector(accountsSlice.selectActiveUser);
    const readOnlyMode = activeUser?.role === Role.User ? true : false;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        event.preventDefault();
    };

    const stopPropagation = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        if (
            (editPanelInfo !== undefined && editPanelInfo.viewPanel) ||
            (actionModalInfo !== undefined && actionModalInfo.isOpen) ||
            contentVersionVis === true
        ) {
            setAnchorEl(null);
        }
    }, [editPanelInfo, actionModalInfo, contentVersionVis]);

    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div onClick={(event) => stopPropagation(event)}>
            <IconButton
                title={targetPopup === 'managementDeploy' ? 'Manage' : undefined}
                onClick={handleClick}
                size={size}
            >
                <MdMoreVert className="react-icon" />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Box p={2}>
                    {['link', 'techu_link'].includes(targetPopup) === true && (
                        <LinkPopup
                            object={object}
                            level={level}
                            onClose={handleClose}
                            readOnlyMode={readOnlyMode}
                            targetPopup={targetPopup}
                        />
                    )}
                    {targetPopup === 'item' && (
                        <ItemPopup object={object} level={level} onClose={handleClose} readOnlyMode={readOnlyMode} />
                    )}
                    {targetPopup === 'zone' && (
                        <ZonePopup object={object} level={level} onClose={handleClose} readOnlyMode={readOnlyMode} />
                    )}
                    {targetPopup === 'asset' && (
                        <AssetPopup
                            object={object}
                            level={level}
                            onClose={handleClose}
                            readOnlyMode={readOnlyMode}
                            activeUser={activeUser}
                        />
                    )}
                    {targetPopup === 'groupManagement' && (
                        <GroupManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'tagManagement' && (
                        <TagManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'clientManagement' && (
                        <ClientManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'audienceManagement' && (
                        <AudienceManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'hotspotManagement' && (
                        <HotspotManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'toolsCategory' && (
                        <ToolsCategoryPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'categoryManagement' && (
                        <CategoryManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'locationManagement' && (
                        <LocationManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'toolManagement' && (
                        <ToolsManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'partGroupManagement' && (
                        <PartsGroupManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'partCategoryManagement' && (
                        <PartsCategoryManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'partManagement' && (
                        <PartsManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'userManagement' && (
                        <UserManagementPopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'userProfile' && (
                        <UserProfilePopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'content' && (
                        <ContentPopup object={object} level={level} onClose={handleClose} readOnlyMode={readOnlyMode} />
                    )}
                    {targetPopup === 'companionApps' && (
                        <CompanionAppsPopup
                            object={object}
                            level={level}
                            onClose={handleClose}
                            readOnlyMode={readOnlyMode}
                        />
                    )}
                    {targetPopup === 'snippet' && (
                        <SnippetPopup object={object} level={level} onClose={handleClose} readOnlyMode={readOnlyMode} />
                    )}
                    {targetPopup === 'newsFlash' && (
                        <NewsFlashPopup
                            object={object}
                            level={level}
                            onClose={handleClose}
                            readOnlyMode={readOnlyMode}
                        />
                    )}
                    {targetPopup === 'managementDeploy' && (
                        <ManagementDeployPackagePopup object={object} level={level} onClose={handleClose} />
                    )}
                    {targetPopup === 'jobStatusAssetExportPopup' && (
                        <JobStatusAssetExportPopup object={object} level={level} onClose={handleClose} />
                    )}
                </Box>
            </Popover>
        </div>
    );
}

export { PopupActions };
